import type { LayoutLoad } from "./$types"
import {
  PUBLIC_SUPABASE_URL,
  PUBLIC_SUPABASE_ANON_KEY,
} from "$env/static/public"
import {
  createBrowserClient,
  createServerClient,
  isBrowser,
} from "@supabase/ssr"

export const load: LayoutLoad = async ({ fetch, data, depends }) => {
  depends("supabase:auth")

  const supabase = isBrowser()
    ? createBrowserClient(PUBLIC_SUPABASE_URL, PUBLIC_SUPABASE_ANON_KEY, {
        global: { fetch },
      })
    : createServerClient(PUBLIC_SUPABASE_URL, PUBLIC_SUPABASE_ANON_KEY, {
        global: { fetch },
        cookies: {
          get(name: string) {
            const cookies = data.cookies as { name: string; value: string }[]
            return cookies.find((cookie) => cookie.name === name)?.value
          },
        },
      })

  const {
    data: { session },
  } = await supabase.auth.getSession()

  return { supabase, session }
}

export const prerender = false
